import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0eec9408"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "choose-coupon-box" }
const _hoisted_2 = { class: "footer-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_ui_table = _resolveComponent("ui-table")!
  const _component_ui_page = _resolveComponent("ui-page")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createBlock(_component_ui_table, {
      data: _ctx.source.list
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "名称",
          "min-width": "140"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_radio, {
              label: true,
              "model-value": _ctx.checkedId === row.id,
              disabled: row.status != 1,
              onChange: ($event: any) => (_ctx.toggle(row))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(row.name), 1)
              ]),
              _: 2
            }, 1032, ["model-value", "disabled", "onChange"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "类型",
          width: "110"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_ctx.getCouponTypeName(row.type)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "优惠内容",
          "min-width": "160"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_ctx.getCouponContent(row)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "库存（剩余/总）",
          width: "130"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_ctx.getCouponStock(row)) + " / " + _toDisplayString(row.count || 0), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "状态",
          width: "80"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("span", {
              class: _normalizeClass(row.status == 1 ? 'status-on' : 'status-off')
            }, _toDisplayString(row.status == 1 ? "生效" : "失效"), 3)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, _ctx.source.loading]
    ]),
    _createVNode(_component_ui_page, {
      modelValue: _ctx.page.page,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.page.page) = $event)),
      info: _ctx.pageInfo
    }, null, 8, ["modelValue", "info"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["tip-text", { 'tip-error': !!_ctx.stockError }])
      }, _toDisplayString(_ctx.stockError || _ctx.stockTip), 3),
      _createElementVNode("div", null, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.choose
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, { onClick: _ctx.cancelEvent }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ])
  ]))
}